<nav class="admin-nav">
    <!-- exact match so Overview doesn't stay active on /dashboard/orders -->
    <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Overview</a>
    <a routerLink="/dashboard/orders" routerLinkActive="active">Orders</a>
    <!-- Admin-only: a canAccessOrders account has no access to the inbox. -->
    @if (session.isAdmin()) {
        <a routerLink="/dashboard/messages" routerLinkActive="active">Messages</a>
    }
</nav>
